import { render } from "./UpdateRsvp.vue?vue&type=template&id=ee969544"
import script from "./UpdateRsvp.vue?vue&type=script&lang=js"
export * from "./UpdateRsvp.vue?vue&type=script&lang=js"
script.render = render

export default script